const ORGANISATION_SPORTS = {
  BASKETBALL: 'Basketball',
  VOLLEYBALL: 'Volleyball',
}

export default ORGANISATION_SPORTS
